export default {
    getCurrentLanguage(state) {
        return state.currentLanguage;
    },
    getAvailableLanguages(state) {
        return state.availableLanguages;
    },
    getCurrentLanguageInfo(state) {
        return state.availableLanguages.find(lang => lang.code === state.currentLanguage);
    }
};

